//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'

export default {
  components: {},
  data () {
    return {
      page: 1,
      limit: 10,
      totals: 0,
      isLoading: false,
      isEnd: false,
      list: []
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getList(true)
    })
  },
  watch: {
    scrollBottom (isBottom) {
      if (isBottom && this.$route.name === 'Article' &&
        !this.isLoading && !this.isEnd) {
        this.page ++
        this.getList()
      }
    }
  },
  computed: {
    ...mapState({
      scrollBottom: state => state.sx.scrollBottom
    }),
    loadingTip () {
      if (this.isLoading) {
        return '正在加载'
      } else if (this.isEnd) {
        return this.list.length ? '没有更多了' : '暂无内容'
      } else {
        return ''
      }
    }
  },
  methods: {
    getList (reLoad) {
      if (reLoad) {
        this.page = 1
        this.isEnd = false
        this.totals = 0
        this.list = []
      }

      this.$post('article/list', {
        type: '200',
        page: this.page,
        limit: this.limit
      }, (res) => {
        if (res.code === 200) {
          this.totals = res.data.totals
          if (res.data.list.length < this.limit) {
            this.isEnd = true
          }
          this.list = this.list.concat(res.data.list)
        }
      })
    },

    viewDetail (item) {
      if (item.viewFlag === 1 && item.url) {
        document.location.href = item.url
      } else if (item.id) {
        this.$router.push({name: 'ArticleView', params: { type: '200', id: item.id }})
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/Article.vue